// @flow
import * as React from "react";
import type { Ranking } from "../../common/types";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Suspense } from "react";
import RankingsRowGraph from "./RankingsRowGraph";
import Avatar from "@material-ui/core/Avatar";
import sams from "../../common/sams";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

type Props = {
  ranking: Ranking,
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatar: {
      height: theme.spacing(4),
      width: theme.spacing(4),
      maxWidth: "100%",
      objectFit: "contain",
    },
  })
);

function RankingsRow({ ranking }: Props) {
  const {
    ballPoints,
    ballQuotient,
    losses,
    matchesPlayed,
    place,
    points,
    setPoints,
    setQuotient,
    wins,
    teamId,
    name,
    shortName,
  } = ranking;
  const classes = useStyles();

  const teamLogo = sams.getTeamLogoById(teamId);
  return (
    <Accordion TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary>
        <Grid
          container
          wrap="nowrap"
          alignItems="center"
          justify="space-between"
          spacing={1}
        >
          <Grid item xs={1}>
            <Typography align="center">
              <b>{place}</b>
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {teamLogo != null ? (
              <img className={classes.avatar} alt={name} src={teamLogo} />
            ) : (
              <Avatar className={classes.avatar} alt={name}>
                {shortName.substring(0, 1)}
              </Avatar>
            )}
          </Grid>
          <Grid item xs={5}>
            <Typography noWrap>{shortName}</Typography>
            <Grid container wrap="nowrap" spacing={1}>
              <Grid item>
                <Typography color="textSecondary" variant="body2">
                  Sp&thinsp;{matchesPlayed}
                </Typography>
              </Grid>
              <Grid item>
                <Typography color="textSecondary" variant="body2">
                  S&thinsp;{wins}
                </Typography>
              </Grid>
              <Grid item>
                <Typography color="textSecondary" variant="body2">
                  N&thinsp;{losses}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Suspense
              fallback={<Skeleton variant="rect" width="100%" height={40} />}
            >
              <RankingsRowGraph id={teamId} />
            </Suspense>
          </Grid>
          <Grid item xs={2}>
            <Typography align="right">
              <b>{points}</b>&thinsp;
              <Typography variant="caption" color="textSecondary">
                Pt
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <DataPoint value={setPoints} label="Sätze" />
          <DataPoint value={setQuotient} label="Satz-Verh." />
          <DataPoint value={ballPoints} label="Bälle" />
          <DataPoint value={ballQuotient} label="Ball-Verh." />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

function DataPoint({ value, label }) {
  return (
    <Grid item>
      <Typography>{value}</Typography>
      <Typography color="textSecondary" variant="caption">
        {label}
      </Typography>
    </Grid>
  );
}

export default RankingsRow;
